import {isNil, isNotNil} from 'ramda';

import {useGetBranchQuery} from '@dms/api/core';
import {useGetCurrentUserInfoQuery} from '@dms/api/customer';
import {useChangeRentalOrderBranchMutation, useGetRentalOrderQuery} from '@dms/api/rental';

import {TestIdProps} from 'shared/web';

import {handleApiError} from '../../../utils/handleApiError';
import {BranchChanger} from './BranchChanger';

export interface BusinessCaseBranchProps extends TestIdProps {
  recordId: string;
}

export function RentalBranch(props: BusinessCaseBranchProps) {
  const {data: rentalOrder} = useGetRentalOrderQuery({
    rentalOrderId: props.recordId,
  });
  const {data: currentUserInfo} = useGetCurrentUserInfoQuery();

  const [changeRentalOrderBranch] = useChangeRentalOrderBranchMutation();

  const userAccessibleBranch = currentUserInfo?.branches?.find(
    (branch) => branch.id === rentalOrder?.branchId
  );

  const {data: branchById} = useGetBranchQuery(
    {branchId: rentalOrder?.branchId ?? ''},
    {skip: isNil(rentalOrder?.branchId) || isNotNil(userAccessibleBranch)}
  );

  const activeBranch = userAccessibleBranch ?? branchById;

  const handleUpdateRentalOrderBranch = (branchId: string) => {
    changeRentalOrderBranch({
      rentalOrderId: props.recordId,
      changeRentalOrderBranchRequestBody: {
        branchId,
      },
    })
      .unwrap()
      .catch(handleApiError);
  };

  return (
    <BranchChanger
      recordId={props.recordId}
      activeBranch={activeBranch}
      onChange={handleUpdateRentalOrderBranch}
      data-testid={props['data-testid']}
    />
  );
}
